<template>
  <base-detail
    v-bind:title="'Продукти в замовленні'"
    v-bind:rootId="rootId"
    v-bind:rootColumn="rootColumn"
    v-bind:schemaName="'orderproduct'"
    v-bind:headers="detailHeaders"
    v-bind:entity="entity"
    v-bind:lookups="lookups"
    v-on:main-save="main - save"
    v-on:on-parrent-load="on - parrent - load"
  >
    <template v-slot="{ entity, add }" class="input-group">
      <form
        v-on:submit.prevent="addProduct(entity, add)"
        class="input-group mb-3 order-product-add-form"
      >
        <div
          class="order-product-add-form__field order-product-add-form__product order-product-add-form__field--floating"
          :class="{ 'order-product-add-form__field--filled': !!selectedProduct }"
        >
          <label class="order-product-add-form__label">{{
            $filters.localize('tableColumns.common.product')
          }}</label>
          <v-select
            class="order-product-add-form__control"
            :options="lookupPagination.entities"
            :modelValue="selectedProduct"
            :append-to-body="true"
            :clearable="true"
            :filterable="false"
            :get-option-label="formatProductRemainOption"
            :loading="lookupLoading"
            :disabled="!canModify"
            @search="onProductSearch"
            @open="onProductLookupOpen"
            @close="onProductLookupClose"
            @update:modelValue="selectProduct"
            @clear="selectProduct(null)"
          >
            <template #option="option">
              <div>{{ formatProductRemainOption(option) }}</div>
            </template>
            <template #selected-option="option">
              <div>{{ formatProductRemainOption(option) }}</div>
            </template>
            <template #list-footer>
              <li
                v-if="lookupLoading || hasMoreLookupPages"
                class="px-3 py-2 border-top text-center text-muted"
              >
                <span v-if="lookupLoading">Завантаження...</span>
              </li>
            </template>
            <template #no-options>
              <span v-if="lookupLoading">Завантаження...</span>
              <span v-else>{{ $filters.localize("select.noOptions") }}</span>
            </template>
          </v-select>
        </div>
        <div
          class="order-product-add-form__field order-product-add-form__size order-product-add-form__field--floating"
          :class="{ 'order-product-add-form__field--filled': !!entity.characterId }"
        >
          <label class="order-product-add-form__label">{{
            $filters.localize("main.size")
          }}</label>
          <select
            class="form-control order-product-add-form__control"
            v-model="entity.characterId"
            :disabled="!canModify"
            required
          >
            <option value="" disabled></option>
            <option
              v-for="option in characters"
              v-bind:key="option.id"
              :value="option.characterId"
            >
              {{ option.character.name }}
            </option>
          </select>
        </div>
        <div
          class="order-product-add-form__field order-product-add-form__quantity order-product-add-form__field--floating"
          :class="{ 'order-product-add-form__field--filled': entity.quantity !== null && entity.quantity !== '' }"
        >
          <label class="order-product-add-form__label">{{
            $filters.localize('main.countTitle')
          }}</label>
          <input
            class="form-control order-product-add-form__control"
            type="number"
            min="1"
            v-model="entity.quantity"
            :disabled="!canModify"
            required
          />
        </div>
        <button
          class="btn btn-primary order-product-add-form__submit"
          type="submit"
          :disabled="!canModify"
        >
          {{ $filters.localize("button.add") }}
        </button>
      </form>
    </template>
  </base-detail>
</template>

<script>
import BaseDetail from "@/components/Sections/BaseDetail.vue";
import vSelect from "vue-select";
export default {
  name: "OrderProductDetail",
  components: { BaseDetail, vSelect },
  emits: ["on-parrent-load", "main-save"],
  props: {
    rootId: { type: String, require: true },
    rootColumn: { type: String, require: true },
    enabled: { type: Boolean },
    canModify: { type: Boolean, default: true },
    orderKind: { type: [Number, String] },
    orderFulfillmentKind: { type: [Number, String] },
    tailoringOnly: { type: Boolean },
  },
  watch: {
    orderFulfillmentKind: {
      handler() {
        this.loadLookups();
      }
    },
  },
  computed: {
    isRetail: {
      get() {
        return this.orderKind === "Retail";
      },
    },
    isTailoring: {
      get() {
        return this.tailoringOnly || this.orderFulfillmentKind === "Tailoring";
      },
    },
    characters: {
      get() {
        var remain = [...(this.selectedProduct?.remains ?? [])];
        return remain.sort((a, b) =>
          (a.character?.name ?? "").localeCompare(b.character?.name ?? "")
        );
      },
    },
    hasMoreLookupPages: {
      get() {
        return this.lookupPagination.page < this.lookupPagination.totalPages;
      },
    },
    detailHeaders: {
      get() {
        const headers = this.headers
          .filter((header) => this.canModify || !header.action)
          .map((header) => ({
            ...header,
            enabeled: header.enabeled ? this.canModify : header.enabeled,
          }));

        if (this.isTailoring) {
          headers.splice(3, 0, {
            field: "product.tailoringTerm.name",
            name: this.$filters.localize("ProductPage.fields.tailoringTerm"),
            sort: true,
            format: this.formatTailoringTerm,
          });
        }

        return headers;
      },
    },
    productCode: {
      get() {
        return this.entity.productCode;
      },
      set(value) {
        let remains = this.lookupPagination.entities.find((x) => x.product.code == value);
        this.entity.productId = remains?.productId;
        this.entity.productCode = value;
        this.entity.price = this.isRetail
          ? remains?.product.price
          : remains?.product.wholeSalePrice;
      },
    },
  },
  methods: {
    formatProductOption(product) {
      if (!product) {
        return "";
      }

      const term = this.isTailoring
        ? product.tailoringTerm?.name ?? product.tailoringTermName ?? ""
        : "";
      const price = this.isRetail ? product.price : product.wholeSalePrice;

      return term
        ? `${product.code} (${term} днів / ${price})`
        : `${product.code} (${price})`;
    },
    formatProductRemainOption(option) {
      return this.formatProductOption(option?.product);
    },
    selectProduct(option) {
      this.selectedProduct = option ?? null;
      this.entity.productId = option?.productId ?? "";
      this.entity.productCode = option?.product?.code ?? "";
      this.entity.characterId = "";
      this.entity.price = this.isRetail
        ? option?.product?.price
        : option?.product?.wholeSalePrice;
    },
    formatTailoringTerm(value) {
      return value ? `${value} днів` : "-";
    },
    loadLookups() {
      this.lookupPagination.page = 1;
      this.searchProduct = "";
      this.selectedProduct = null;
      this.lookupPagination.entities = [];
      this.lookupPagination.totalPages = 0;
      this.cancelProductLookupRequest();
    },
    onProductLookupOpen() {
      this.bindLookupScroll();
      if (this.lookupPagination.entities.length === 0) {
        this.lookupPagination.page = 1;
        this.loadProductLookup({ append: false });
      }
    },
    onProductLookupClose() {
      this.unbindLookupScroll();
    },
    onProductSearch(value) {
      const search = value?.trim() ?? "";
      if (!search && this.selectedProduct) {
        return;
      }

      this.searchProduct = search;
      this.lookupPagination.page = 1;
      this.selectProduct(null);
      window.clearTimeout(this.productSearchTimeout);
      this.productSearchTimeout = window.setTimeout(() => {
        this.loadProductLookup({ append: false });
      }, 250);
    },
    loadProductLookup({ append = false } = {}) {
      if (append && this.lookupLoading) {
        return Promise.resolve();
      }

      this.cancelProductLookupRequest();
      const controller = new AbortController();
      this.productLookupAbortController = controller;
      this.lookupLoading = true;
      const requestId = ++this.productLookupRequestId;
      const params = new URLSearchParams({
        page: this.lookupPagination.page,
        size: this.lookupPagination.packageSize,
      });

      if (this.isTailoring) {
        params.set("tailoringOnly", true);
        params.set("outOfStockOnly", true);
      }

      if (this.searchProduct) {
        params.set("search", this.searchProduct);
      }

      return this.$store
        .dispatch("get", {
          table: "productremains",
          method: "search?" + params.toString(),
          signal: controller.signal,
        })
        .then((response) => {
          if (requestId !== this.productLookupRequestId) {
            return;
          }

          const data = response.data.data;
          this.lookupPagination = {
            ...data,
            entities: append
              ? this.mergeLookupEntities(
                this.lookupPagination.entities,
                data.entities ?? []
              )
              : data.entities ?? [],
          };
        })
        .catch((error) => {
          if (error.code !== "ERR_CANCELED") {
            throw error;
          }
        })
        .finally(() => {
          if (requestId === this.productLookupRequestId) {
            this.lookupLoading = false;
            this.productLookupAbortController = null;
          }
          this.bindLookupScroll();
        });
    },
    cancelProductLookupRequest() {
      if (this.productLookupAbortController) {
        this.productLookupAbortController.abort();
        this.productLookupAbortController = null;
      }
    },
    mergeLookupEntities(currentItems, nextItems) {
      const map = new Map();
      [...currentItems, ...nextItems].forEach((item) => {
        map.set(item.productId, item);
      });
      return [...map.values()];
    },
    bindLookupScroll() {
      this.unbindLookupScroll();
      this.$nextTick(() => {
        const dropdowns = document.querySelectorAll(".vs__dropdown-menu");
        const dropdownMenu = dropdowns[dropdowns.length - 1];
        if (!dropdownMenu) {
          return;
        }

        dropdownMenu.addEventListener("scroll", this.onLookupScroll);
        this.lookupScrollElement = dropdownMenu;
      });
    },
    unbindLookupScroll() {
      if (!this.lookupScrollElement) {
        return;
      }

      this.lookupScrollElement.removeEventListener("scroll", this.onLookupScroll);
      this.lookupScrollElement = null;
    },
    onLookupScroll(event) {
      const element = event.target;
      const threshold = 24;
      const isNearBottom =
        element.scrollTop + element.clientHeight >=
        element.scrollHeight - threshold;

      if (!isNearBottom || this.lookupLoading || !this.hasMoreLookupPages) {
        return;
      }

      this.lookupPagination.page += 1;
      this.loadProductLookup({ append: true });
    },

    addProduct(entity, callback) {
      if (!this.canModify) {
        return;
      }

      if (!this.enabled) this.save(entity, callback);
      else this.add(entity, callback);
    },

    add(entity, callback) {
      this.$store
        .dispatch("post", {
          table: "Order",
          method: "addproduct",
          body: JSON.parse(JSON.stringify(entity)),
        })
        .then((response) => {
          this.loadLookups();
          callback(response.data.data);
          this.$emit("on-parrent-load");
        })
        .catch((error) => this.$toast.error(error.response.data.message));
    },

    save(entity, callback) {
      new Promise((resolve, reject) => {
        this.$emit("main-save", null, resolve, reject);
      }).then(() => this.add(entity, callback));
    },
  },
  data() {
    return {
      lookups: {
        remains: [],
      },
      lookupLoading: false,
      lookupPagination: {
        page: 1,
        count: 0,
        packageSize: 10,
        totalPages: 0,
        entities: [],
      },
      lookupScrollElement: null,
      searchProduct: "",
      productSearchTimeout: null,
      productLookupRequestId: 0,
      productLookupAbortController: null,
      selectedProduct: null,
      entity: {
        activityId: this.rootId,
        characterId: "",
        productId: "",
        productCode: "",
        quantity: null,
        price: null,
      },
      headers: [
        { field: "product.image", name: "Зображення", image: true },
        { field: "product.code", name: "Продукт", sort: true },
        {
          field: "productRemain.character.name",
          name: this.$filters.localize("main.size"),
          sort: true,
        },
        {
          field: "price",
          name: "Ціна",
          sort: true,
          input: { type: "numeric" },
          enabeled: true,
        },
        {
          field: "quantity",
          name: this.$filters.localize("main.countTitle"),
          sort: true,
          input: { type: "numeric" },
          enabeled: true,
        },
        { field: "id", name: "Дія", action: true },
      ],
    };
  },
  beforeUnmount() {
    window.clearTimeout(this.productSearchTimeout);
    this.cancelProductLookupRequest();
    this.unbindLookupScroll();
  },
};
</script>

<style scoped>
.order-product-add-form {
  flex-wrap: wrap;
  align-items: stretch;
  gap: 6px;
  position: relative;
  z-index: 20;
  width: 100%;
}

.order-product-add-form__field {
  flex: 1 1 0;
  min-width: 0;
  height: 36px;
  min-height: 36px;
  position: relative;
}

.order-product-add-form__field + .order-product-add-form__field,
.order-product-add-form__submit {
  margin-left: 0;
}

.order-product-add-form__field:focus-within,
.order-product-add-form__control:focus {
  z-index: 2;
}

.order-product-add-form__label {
  margin: 0;
  color: #7b8794;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1;
  pointer-events: none;
}

.order-product-add-form__field--floating .order-product-add-form__label {
  position: absolute;
  top: 50%;
  left: 12px;
  z-index: 3;
  max-width: calc(100% - 24px);
  overflow: hidden;
  transform: translateY(-50%);
  transition: top 0.14s ease, transform 0.14s ease, font-size 0.14s ease, color 0.14s ease;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.order-product-add-form__field--floating:focus-within .order-product-add-form__label,
.order-product-add-form__field--floating.order-product-add-form__field--filled .order-product-add-form__label {
  top: 6px;
  transform: none;
  color: #4f7fa7;
  font-size: 0.58rem;
  text-transform: uppercase;
}

.order-product-add-form__control {
  width: 100%;
  height: 36px;
  min-height: 36px;
  border-color: #ced4da;
  border-radius: 0.25rem;
  position: relative;
}

.order-product-add-form__field--floating .form-control.order-product-add-form__control {
  padding: 14px 12px 2px;
}

.order-product-add-form__size.order-product-add-form__field--filled .order-product-add-form__control {
  padding-top: 12px;
  padding-bottom: 0;
  line-height: 1.2;
}

.order-product-add-form__field--floating:not(.order-product-add-form__field--filled):not(:focus-within) .form-control.order-product-add-form__control {
  color: transparent;
}

.order-product-add-form__field--floating:not(.order-product-add-form__field--filled):not(:focus-within) .form-control.order-product-add-form__control option {
  color: #495057;
}

.order-product-add-form__product {
  min-width: 180px;
}

.order-product-add-form__size {
  min-width: 140px;
}

.order-product-add-form__quantity {
  min-width: 120px;
}

.order-product-add-form__submit {
  flex: 0 0 auto;
  height: 36px;
  min-height: 36px;
  padding-inline: 1rem;
  white-space: nowrap;
  border-radius: 0.25rem;
  position: relative;
  z-index: 1;
}

.order-product-add-form__product :deep(.vs__dropdown-toggle) {
  height: 36px;
  min-height: 36px;
  padding: 0;
  border-color: #ced4da;
  border-radius: 0.25rem;
  background: #fff;
}

.order-product-add-form__product :deep(.vs__dropdown-menu) {
  z-index: 30;
}

.order-product-add-form__product :deep(.vs__selected-options) {
  flex-wrap: nowrap;
  min-width: 0;
  height: 34px;
  padding: 12px 0.5rem 2px;
  overflow: hidden;
}

.order-product-add-form__product :deep(.vs__search),
.order-product-add-form__product :deep(.vs__selected) {
  margin: 0;
  line-height: 1.2;
}

.order-product-add-form__product :deep(.vs__search) {
  min-width: 0;
  padding: 0;
}

.order-product-add-form__product :deep(.vs__selected) {
  min-width: 0;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.order-product-add-form__product :deep(.vs__actions) {
  align-items: center;
  height: 34px;
  padding: 0 8px 0 4px;
}

.order-product-add-form__size .order-product-add-form__control,
.order-product-add-form__quantity .order-product-add-form__control {
  border-radius: 0.25rem;
}

@media (max-width: 576px) {
  .order-product-add-form {
    gap: 0.5rem;
  }

  .order-product-add-form__field,
  .order-product-add-form__submit {
    flex-basis: 100%;
    width: 100%;
    margin-left: 0;
    border-radius: 0.25rem;
  }

  .order-product-add-form__product :deep(.vs__dropdown-toggle) {
    border-radius: 0.25rem;
  }

  .order-product-add-form__size .order-product-add-form__control,
  .order-product-add-form__quantity .order-product-add-form__control {
    border-radius: 0.25rem;
  }
}
</style>
